const redColor = "tw:bg-red-400"
const greenColor = "tw:bg-green-400"
const yellowColor = "tw:bg-yellow-300"
const orangeColor = "tw:bg-orange-300"

export const STATUS_COLOR_MAP: Record<string, string> = {
  // RED
  PROVIDER_VERIFICATION_FAILED_SUBMIT: redColor,
  MARKET_REJECT: redColor,
  REJECT: redColor,
  QA_REVIEW: redColor,
  INACTIVE: redColor,
  VERIFICATION_CANCELLED: redColor,
  CANCELLED: redColor,
  DUPLICATE: redColor,
  INELIGIBLE: redColor,

  // GREEN
  ACTIVE: greenColor,
  MARKET_ENROLL_ACCEPT: greenColor,
  MARKET_REINSTATE: greenColor,

  // YELLOW
  INITIAL: yellowColor,
  VERIFICATION_SUBMIT: yellowColor,
  VERIFICATION_ACCEPT: yellowColor,
  PENDING_PROVIDER_SUBMIT: yellowColor,
  PENDING_PROVIDER_RESUBMIT: yellowColor,
  PROVIDER_SUBMIT: yellowColor,
  PROVIDER_ACCEPT: yellowColor,
  VERIFICATION_PASS: yellowColor,
  VERIFICATION_FAIL: yellowColor,
  VERIFICATION_RETRY: yellowColor,
  VERIFICATION_REQUEST_FAILURE: yellowColor,
  PROVIDER_SUBMIT_RETRY: yellowColor,
  PROVIDER_SUBMIT_FAILURE: yellowColor,
  PROVIDER_VERIFICATION_PENDING: yellowColor,
  PROVIDER_VERIFICATION_SUBMIT: yellowColor,
  MARKET_ENROLL_REQUEST: yellowColor,

  // ORANGE
  CANCEL_PENDING: orangeColor,
  DROP_REQUEST: orangeColor,
  DROP_REJECT: orangeColor,
  DROP_REQUEST_DUAL_BILLING: orangeColor,
  DROP_ACCEPT: orangeColor,
  MOVE_PENDING: orangeColor,
}
